import { useState } from "react";
import { FiDownload, FiExternalLink } from "react-icons/fi";
import { Card, PageHeader, Tabs } from "../../components/common";
import { useRole } from "../../context/RoleContext";
import { VIEW_LABELS } from "../../services/navigation";
import { docxUrl, manualsFor, pdfUrl, DEMO_GUIDE, showsDemoGuide } from "../../manual/manualFiles";

export default function UserManualPage() {
  const { availableViews, activeView } = useRole();
  const views = manualsFor(availableViews);
  const [view, setView] = useState(views.includes(activeView) ? activeView : views[0]);

  const demo = showsDemoGuide(availableViews);
  const tabs = [...views.map((v) => ({ key: v, label: `${VIEW_LABELS[v]} manual` })), ...(demo ? [{ key: DEMO_GUIDE, label: "Demo guide" }] : [])];
  const titleOf = (v) => (v === DEMO_GUIDE ? "Demo guide" : `${VIEW_LABELS[v]} user manual`);
  const names = views.map((v) => VIEW_LABELS[v]).join(", ");

  return (
    <div className="page manual-page">
      <PageHeader
        title="User manual"
        subtitle={`Step-by-step help for your role${views.length > 1 ? "s" : ""}: ${names}.`}
        actions={
          <>
            <a className="btn btn-secondary" href={pdfUrl(view)} target="_blank" rel="noreferrer"><FiExternalLink size={16} aria-hidden="true" /><span>Open in new tab</span></a>
            <a className="btn btn-secondary" href={docxUrl(view)} download><FiDownload size={16} aria-hidden="true" /><span>Download Word</span></a>
            <a className="btn btn-primary" href={pdfUrl(view)} download><FiDownload size={16} aria-hidden="true" /><span>Download PDF</span></a>
          </>
        }
      />

      {tabs.length > 1 && <Tabs tabs={tabs} value={view} onChange={setView} />}

      <Card padded={false}>
        <iframe key={view} title={titleOf(view)} src={`${pdfUrl(view)}#view=FitH`} className="manual-frame" />
      </Card>
      <p className="manual-fallback">Cannot see the manual above? Use Open in new tab or Download PDF.</p>
    </div>
  );
}
